import styled from "styled-components";

import { Link } from "react-router-dom";
import { Table, Button } from "semantic-ui-react";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #ffffff;
`;

export const Content = styled.div`
  max-width: 80vw;

  margin: auto;
`;

export const Title = styled.h1`
  width: 100%;
  margin: 15px 0px 15px 0px;
  padding: 0px;

  color: #000020;

  font-size: 24px;
  font-family: sans-serif;
  font-weight: 600;

  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
`;

export const ContainerInputSearch = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;

  & i {
    height: 75% !important;
  }
  input {
    width: 80%;
  }
  button {
    text-align: center;
    width: 40rem;
    margin-left: 4px !important;
  }
`;

export const Input = styled.input`
  height: 35px;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const SemanticTable = styled(Table)`
  border-collapse: collapse;
  margin-top: 2em;
  font-size: 1em;

  th {
    padding: 1em;
    justify-content: center;
    max-width: 33.333%;
  }

  tbody {
    tr {
      :hover {
        background: rgba(34, 36, 38, 0.1);
      }

      td {
        padding: 15px;
        max-width: 33.333%;
        justify-content: center;
      }
    }
  }

  tfoot {
    a {
      color: #000000 !important;

      i {
        color: #000000 !important;
      }
    }
  }
`;

export const LinkRedirect = styled(Link)`
  color: #2185d0 !important;
  cursor: default;

  &:hover {
    text-decoration: none;
    color: #2d8cd4 !important;
  }
`;

export const ContainerPaginate = styled.div`
  display: flex;
  justify-content: center;
`;

export const Select = styled.select`
  margin: 1rem auto;
  font-size: 1em;
  width: 80%;
  display: block;
  border-radius: 0.5rem;
  font-family: sans-serif !important;
  font-weight: 300;
  font-size: 16px !important;
  padding: 0.5rem;
`;

export const FilterSelect = styled.select`
  font-size: 16px;
  margin: 0 1rem;
  padding: 0 1rem;
  height: 35px;
`;
